module.exports = __webpack_public_path__ + "img/68.f4e20d38.jpg";